import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('toll', 'el peaje', 'los peajes')

export default {
	...actions,
}
